var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppiloIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "transparent"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 23,
    textAnchor: "middle",
    fontFamily: "serif",
    fontSize: 26,
    fill: "#177ddc"
  }, "\u03B1")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppiloIcon);
export default __webpack_public_path__ + "static/media/appilo-icon.0e3c1ea6c85bc939df5f32bc7af3701a.svg";
export { ForwardRef as ReactComponent };